import axios                                   from 'axios';
import {getUserToken, getAppLang, getProperty} from "../../../../utils";
import {PUBLISH_WEB} from "../../../../constants/api.constants";


export function publishWebSubmit(params, id) {

    const isPublish = (params && params.is_publish !== undefined) ? params.is_publish : 1;

    const requestOptions = {
        headers: { 'Content-Type': 'application/json',  'authToken': getUserToken(), 'language' : getAppLang()},
        body: {
            params: {
                property_id : getProperty(),
                property_web_id : id,
                is_publish : isPublish,
                full : true
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'PUBLISH_WEB',
            payload: axios.post(PUBLISH_WEB, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}


